import { getProductShortName } from 'BrokerTsLib/src/enums'
import React, { useEffect } from 'react'

import { CustomWaypoint } from '@/components/CustomWaypoint'
import { PageSection } from '@/components/PageSection'
import { useSidebar } from '@/context/SidebarContext'
import { useAvailableProducts } from '@/hooks/useProducts'
import type { PageSection as Section } from '@/layouts/components/Sidebar'

import { ProductDiscountsOverview } from './ProductDiscountsOverview'

export const DiscountsOverview = () => {
  const products = useAvailableProducts()
  const { pageSections, setPageSections } = useSidebar()

  useEffect(() => {
    const array: Section[] = []
    let i = 1

    for (const product of products) {
      array.push({
        id: product,
        sectionTitle: getProductShortName(product),
        index: i++,
        children: (
          <CustomWaypoint sectionId={product}>
            <PageSection id={product}>
              <ProductDiscountsOverview product={product} />
            </PageSection>
          </CustomWaypoint>
        ),
      })
    }

    setPageSections(array)
    return () => setPageSections([])
  }, [products, setPageSections])

  return pageSections.map((x) => (
    <React.Fragment key={x.id}>{x.children}</React.Fragment>
  ))
}
